import './css/styles.scss';

const initPostSwiper = function () {
};

document.addEventListener('DOMContentLoaded', function () {
	initPostSwiper();
});